export enum CheckMode {
  Building,
  Location,
  Both,
}

export interface IDPair {
  url?: number;
  given?: number;
}

export type OnMismatchCB = (
  location?: IDPair, 
  building?: IDPair
) => void;

const checkLocationsURL = (
  cb: OnMismatchCB, 
  mode: CheckMode, 
  location?: number, 
  building?: number
) => {
  const params = new URLSearchParams(window.location.search);
  
  const urlLocation = params.get('location');
  const urlBuilding = params.get('building');
  
  const urlLocationId = urlLocation ? parseInt(urlLocation, 10) : undefined;
  const urlBuildingId = urlBuilding ? parseInt(urlBuilding, 10) : undefined;
  
  let locationDiff: IDPair | undefined;
  let buildingDiff: IDPair | undefined;
  
  const shouldCheckLocation = mode === CheckMode.Location || mode === CheckMode.Both;
  const shouldCheckBuilding = mode === CheckMode.Building || mode === CheckMode.Both;
  
  if (shouldCheckLocation && urlLocationId !== location) {
    locationDiff = {
      url: urlLocationId,
      given: location,
    };
  }
  
  if (shouldCheckBuilding && urlBuildingId !== building) {
    buildingDiff = {
      url: urlBuildingId,
      given: building,
    };
  }
  
  if (locationDiff || buildingDiff) {
    cb(locationDiff, buildingDiff);
  }
};

export default checkLocationsURL;